import React from 'react';
import './Legal.css';

export default function Terms() {
  return (
    <div className="page legal-page">
      <div className="legal-hero">
        <div className="container animate-fade-up">
          <span className="eyebrow">Legal</span>
          <h1 className="display-title" style={{ fontSize: '2.4rem' }}>Terms of Service</h1>
          <p className="legal-hero__sub">Last updated: January 1, 2026</p>
        </div>
      </div>
      <div className="section">
        <div className="container legal-content animate-fade-up">

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing or using any PERM Systems bot, website, or service ("Services"),
              you agree to be bound by these Terms of Service and to abide by the{' '}
              <a href="https://discord.com/terms" target="_blank" rel="noopener noreferrer">Discord Terms of Service</a>{' '}
              and the{' '}
              <a href="https://discord.com/privacy" target="_blank" rel="noopener noreferrer">Discord Privacy Policy</a>.
              If you do not agree to these terms, please do not use our Services.
            </p>
          </section>

          <section>
            <h2>2. Use of Services</h2>
            <p>
              Our Services are intended for use by{' '}
              <a href="https://discord.com" target="_blank" rel="noopener noreferrer">Discord</a>{' '}
              communities for legitimate purposes. By using PERM Systems or any of its bots,
              you agree to abide by the{' '}
              <a href="https://discord.com/terms" target="_blank" rel="noopener noreferrer">Discord Terms of Service</a>{' '}
              and the{' '}
              <a href="https://discord.com/privacy" target="_blank" rel="noopener noreferrer">Discord Privacy Policy</a>.
              You further agree not to:
            </p>
            <ul>
              <li>Use the Services to violate the <a href="https://discord.com/terms" target="_blank" rel="noopener noreferrer">Discord Terms of Service</a> or <a href="https://discord.com/guidelines" target="_blank" rel="noopener noreferrer">Discord Community Guidelines</a>.</li>
              <li>Attempt to gain unauthorised access to any part of the Services.</li>
              <li>Use the Services to harass, abuse, or harm others.</li>
              <li>Reverse-engineer, decompile, or copy any part of our bots or software.</li>
              <li>Use the Services for any unlawful purpose under applicable law.</li>
              <li>Attempt to overload, disrupt, or abuse the Services or their underlying infrastructure.</li>
            </ul>
          </section>

          <section>
            <h2>3. Our Services</h2>
            <p>
              PERM Systems builds and operates{' '}
              <a href="https://discord.com/developers/docs/intro" target="_blank" rel="noopener noreferrer">Discord bots</a>{' '}
              designed to improve the developer experience on the Discord platform.
              We do not offer custom bot development for individual servers or organisations.
              We welcome recommendations for new bots via our{' '}
              <a href="https://discord.gg/permsystems" target="_blank" rel="noopener noreferrer">Discord support server</a>.
            </p>
          </section>

          <section>
            <h2>4. AI-Powered Features</h2>
            <p>
              Code Assist uses a proprietary AI model owned and operated by PERM Systems.
              AI-generated responses are provided for informational and assistive purposes only.
              You should review all AI-generated code before using it in production.
              PERM Systems is not responsible for errors, bugs, or security issues arising from
              code generated or suggested by the bot.
            </p>
          </section>

          <section>
            <h2>5. Bot Commands and Data</h2>
            <p>
              When you use PERM Systems bots, certain command inputs and server configurations
              may be stored to provide the Services. We do not sell this data to third parties.
              See our <a href="/privacy">Privacy Policy</a> for full details on how we handle
              and retain data.
            </p>
          </section>

          <section>
            <h2>6. Availability</h2>
            <p>
              We strive for maximum uptime but cannot guarantee 100% availability. We reserve the right
              to perform maintenance, updates, or modifications at any time. PERM Systems will endeavour
              to notify users of planned downtime via the{' '}
              <a href="https://discord.gg/permsystems" target="_blank" rel="noopener noreferrer">Discord support server</a>.
            </p>
          </section>

          <section>
            <h2>7. Intellectual Property</h2>
            <p>
              All PERM Systems software, branding, logos, AI models, and content are the intellectual
              property of PERM Systems. You may not reproduce, redistribute, or create derivative works
              from our materials without prior written permission.
            </p>
          </section>

          <section>
            <h2>8. Disclaimer of Warranties</h2>
            <p>
              The Services are provided "as is" without warranties of any kind, express or implied.
              PERM Systems does not warrant that the Services will be error-free, uninterrupted, or
              free of harmful components.
            </p>
          </section>

          <section>
            <h2>9. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by applicable law, PERM Systems shall not be liable
              for any indirect, incidental, special, consequential, or punitive damages arising
              from your use of the Services.
            </p>
          </section>

          <section>
            <h2>10. Changes to These Terms</h2>
            <p>
              We may update these Terms at any time. Continued use of the Services after changes
              are posted constitutes acceptance of the revised Terms. We will notify users of
              significant changes via the{' '}
              <a href="https://discord.gg/permsystems" target="_blank" rel="noopener noreferrer">PERM Systems Discord server</a>.
            </p>
          </section>

          <section>
            <h2>11. Contact</h2>
            <p>
              Questions about these Terms? Contact us at{' '}
              <a href="mailto:support@permsystems.com">support@permsystems.com</a>{' '}
              or through our{' '}
              <a href="https://discord.gg/permsystems" target="_blank" rel="noopener noreferrer">Discord support server</a>.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
}